export default "__VITE_ASSET__35b1daa1__"